import type { ImageSpecLayer } from '@/lib/imageSpecs';

/**
 * Image shapes more than one theme draws, written once.
 *
 * Its own module rather than a constant in `meta.ts`: that module globs every
 * theme's `meta.ts` eagerly, and a theme importing a *value* back out of it
 * would be read before it was defined. Type-only imports of `meta.ts` are
 * fine; this is where the shared values go instead.
 */

/**
 * The product photo for a theme whose shelves wear the `airy` card.
 *
 * `ProductCard` draws that card `aspect-[3/4]`, and the picture inside it is
 * `object-contain` - so a square photo is not cropped there, it is letterboxed,
 * with a band of surface colour above and below every product on the shelf.
 * The sizes are the default's re-derived for the taller shape on the same long
 * edge (as `specForAspect` would), so asking for portrait does not ask the
 * merchant for more pixels than a square did.
 *
 * The safe area is wider than the default's because the product page on these
 * themes is not 3:4: it is 4:5 on editorial and serra and square on minimal,
 * both `object-cover`, and the square trims an eighth off the top and bottom
 * of a portrait photo. What sits inside the guide survives both.
 */
export const AIRY_PRODUCT_CARD: ImageSpecLayer = {
  aspect: { width: 3, height: 4 },
  recommendedWidth: 1500,
  recommendedHeight: 2000,
  minWidth: 600,
  minHeight: 800,
  safeArea: 0.13,
};
